import { FC } from 'react';
import { Box, makeStyles, Theme } from '@material-ui/core';
import {
  AiIcon,
  useEnabledFeatures,
  WbButton,
} from '@agilelab/plugin-wb-platform';
import { useEditorPageContext } from '../context/useEditorPageContext';
import { LaunchTestButton } from './LaunchTestButton';

const useStyles = makeStyles<Theme>(
  theme => ({
    autofixButton: {
      color: theme.palette.accent.main,
      backgroundColor: theme.palette.white,
      border: 'solid 1px transparent',
      background:
        'linear-gradient( #ffffff, #ffffff) padding-box,linear-gradient(90deg, #EE72D3, #7C4DFF) border-box',
    },
  }),
  { name: 'TestCardActions' },
);

export const TestCardActions: FC = () => {
  const classes = useStyles();
  const { setIsAutofixDrawerOpen } = useEditorPageContext();
  const { data: features } = useEnabledFeatures();

  return (
    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
      {features.wittyAutofixEnabled && (
        <WbButton
          variant="outlined"
          startIcon={<AiIcon />}
          label="Fix with Witty"
          className={classes.autofixButton}
          onClick={() => setIsAutofixDrawerOpen(true)}
        />
      )}
      <LaunchTestButton />
    </Box>
  );
};
